import "./mini-shop-section.styles.css";
import MiniShopLabel from "../mini-shop-label/mini-shop-lable.component";
import { IoChevronDown } from "react-icons/io5";
import MiniShopDirectory from "../mini-shop-directory/mini-shop-directory.component";
import { useState } from "react";
import FilterLabel from "../filter-label/filter-label.component";
import { Link } from "react-router-dom";

const MiniShopSection = () => {
  const [selectedCategory, setSelectedCategory] = useState("محصولات");

  const MiniShopLabelsData = [
    { id: 1, text: "همه محصولات" },
    { id: 2, text: "بالاتنه" },
    { id: 3, text: "پایین تنه" },
    { id: 4, text: "اکسسوری" },
  ];

  const handleLabelClick = (category) => {
    setSelectedCategory(category);
  };

  return (
    <div className="mini-shop-section">
      <div className="mini-shop-labels-section">
        <div className="lables-buttons-wrapper">
          {MiniShopLabelsData.map((label) => (
            <MiniShopLabel
              key={label.id}
              cat={label}
              onClick={() => handleLabelClick(label.text)}
              isSelected={label.text === selectedCategory}
            />
          ))}
        </div>
        {/* <FilterLabel /> */}
      </div>
      <MiniShopDirectory selectedCategory={selectedCategory} />
      <div className="see-all-btn">
        <Link to="/shop-page">
          <button className="btn-shop">همه محصولات</button>
        </Link>
      </div>
    </div>
  );
};

export default MiniShopSection;
